import { object } from 'valibot';

import { PasswordSchema } from './password-schema';
import { stringRequired } from './schema.utils';

export const ChangePasswordSchema = () =>
  object({
    oldPassword: stringRequired(),
    password: PasswordSchema(),
    confirmPassword: PasswordSchema()
  });
